import { render, staticRenderFns } from "./crossDistrict.vue?vue&type=template&id=2e2a26c4&scoped=true&"
import script from "./crossDistrict.vue?vue&type=script&lang=js&"
export * from "./crossDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a26c4",
  null
  
)

export default component.exports